<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "../components/loader";
import { OveviewChart, activitiesData } from "../../views/datafake/data-clientes";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";



export default {
  page: {
    title: "Clientes",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      clienteData: {

      },
      idData: 0,
      updating: true,
      OveviewChart: OveviewChart,
      activitiesData: activitiesData,
      title: "Detalhes Cliente",
      items: [
        {
          text: "Clientes",
          href: "/clientes/list",
        },
        {
          text: "Detalhes Cliente",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [
        { text: '10', value: '10' },
        { text: '25', value: '25' },
        { text: '50', value: '50' },
        { text: '100', value: '100' }
      ],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "date",
          label: "Data",
          sortable: true,
        },
        {
          key: "type",
          label: "Condição",
          sortable: true,
        },
        {
          key: "currency",
          label: "Produto Destaque",
          sortable: true,
        },
        {
          key: "amount",
          label: "Peso",
          sortable: true,
        },
        {
          key: "usd",
          label: "Valor",
          class: "text-end",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.activitiesData.length;
    },
  },
  mounted() {
    console.log('mounted cliente-detalhe_0')

    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)
    if (this.idData > 0){
      api.get(`${getBaseUrl()}api/cliente`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.clienteData = res.data[0]
        this.idData = this.clienteData.id
        this.title = `Detalhes Cliente (${this.clienteData.id}) ${this.clienteData.nome}`
        this.updating = false
      });
    }
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!updating">
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">
              <div class="flex-shrink-0 me-4">
                <i class="mdi mdi-account-circle text-primary h1"></i>
              </div>

              <div class="flex-grow-1">
                <div class="text-muted">
                  <h5>{{ clienteData.nome }}</h5>
                  <p class="mb-1">{{ clienteData.email }}</p>
                  <p class="mb-0">Id: {{ clienteData.id }}</p>
                </div>
              </div>

              <b-dropdown
                  variant="white"
                  toggle-class="text-muted p-0"
                  toggle-tag="div"
              >
                <template v-slot:button-content>
                  <i class="mdi mdi-dots-horizontal font-size-18"></i>
                </template>
                <b-dropdown-item>Compartilhar</b-dropdown-item>
                <b-dropdown-item>Enviar Whatsapp</b-dropdown-item>
                <b-dropdown-item>Enviar Email</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div class="card-body border-top">
            <div class="row">
              <div class="col-sm-6">
                <div>
                  <p class="text-muted mb-2">Limite Disponível</p>
                  <h5>R$ 92.148,23</h5>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="text-sm-end mt-4 mt-sm-0">
                  <p class="text-muted mb-2">Comparativo Mensal</p>
                  <h5>
                    + R$ 24.884,35
                    <span class="badge bg-success ms-1 align-bottom"
                    >+ 14,0 %</span
                    >
                  </h5>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body border-top">
            <p class="text-muted mb-4">Este mês</p>
            <div class="text-center">
              <div class="row">
                <div class="col-sm-4">
                  <div>
                    <div class="font-size-24 text-primary mb-2">
                      <i class="bx bx-money"></i>
                    </div>

                    <p class="text-muted mb-2">Faturado</p>
                    <h5>R$ 654.877,42</h5>

                    <div class="mt-3">
                      <a href="#" class="btn btn-primary btn-sm w-md">Detalhes</a>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="mt-4 mt-sm-0">
                    <div class="font-size-24 text-primary mb-2">
                      <i class="bx bx-import"></i>
                    </div>

                    <p class="text-muted mb-2">Confirmado</p>
                    <h5>R$ 10.054,32</h5>

                    <div class="mt-3">
                      <a href="#" class="btn btn-primary btn-sm w-md"
                      >Detalhes</a
                      >
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="mt-4 mt-sm-0">
                    <div class="font-size-24 text-primary mb-2">
                      <i class="bx bx-wallet"></i>
                    </div>

                    <p class="text-muted mb-2">Elaboração</p>
                    <h5>R$ 824,34</h5>

                    <div class="mt-3">
                      <a href="#" class="btn btn-primary btn-sm w-md"
                      >Detalhes</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-8">
        <div class="row">
          <div class="col-sm-4">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="d-flex">
                  <div class="me-3 align-self-center">
                    <i class="mdi mdi-cart h2 text-warning mb-0"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="text-muted mb-2">Último Pedido</p>
                    <h5 class="mb-0">
                      25/03/2023
                      <span class="font-size-14 text-muted"> R$ 91.480,00 </span>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="d-flex">
                  <div class="me-3 align-self-center">
                    <i class="mdi mdi-handshake h2 text-primary mb-0"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="text-muted mb-2">Última Visita</p>
                    <h5 class="mb-0">
                      01/01/1990
                      <span class="font-size-14 text-muted"> R$ 8.235,00 </span>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="d-flex">
                  <div class="me-3 align-self-center">
                    <i class="mdi mdi-ticket-outline h2 text-info mb-0"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="text-muted mb-2">Ticket Médio</p>
                    <h5 class="mb-0">
                      30 kg
                      <span class="font-size-14 text-muted"> R$ 47.201,00 </span>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end row -->

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Overview</h4>

            <div>
              <apexchart
                  class="apex-charts"
                  height="228"
                  type="line"
                  dir="ltr"
                  :series="OveviewChart.series"
                  :options="OveviewChart.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="row" v-if="!updating">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Últimas atividades</h4>
            <b-tabs content-class="mt-3" nav-class="nav-tabs-custom">
              <b-tab title="Pedidos" active>
<!--                <div class="row mt-4">-->
<!--                  <div class="col-sm-12 col-md-6">-->
<!--                    <div id="tickets-table_length" class="dataTables_length">-->
<!--                      <label class="d-inline-flex align-items-center fw-normal">-->
<!--                        Show&nbsp;-->
<!--                        <select-->
<!--                            v-model="perPage"-->
<!--                            size="sm"-->
<!--                            class="form-control form-select form-select-sm"-->
<!--                        >-->
<!--                          <option v-for="option in pageOptions" :key="option.value" :value="option.value">-->
<!--                            {{ option.text }}-->
<!--                          </option>-->
<!--                        </select-->
<!--                        >-->
<!--                        &nbsp;entries-->
<!--                      </label>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  &lt;!&ndash; Search &ndash;&gt;-->
<!--                  <div class="col-sm-12 col-md-6">-->
<!--                    <div-->
<!--                        id="tickets-table_filter"-->
<!--                        class="dataTables_filter text-md-end"-->
<!--                    >-->
<!--                      <label class="d-inline-flex align-items-center">-->
<!--                        Search:-->
<!--                        <b-form-input-->
<!--                            v-model="filter"-->
<!--                            type="search"-->
<!--                            class="form-control form-control-sm ms-2"-->
<!--                        ></b-form-input>-->
<!--                      </label>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  &lt;!&ndash; End search &ndash;&gt;-->
<!--                </div>-->
                <!-- Table -->
                <div class="table-responsive table-hover mb-0">
                  <b-table
                      :items="activitiesData"
                      :fields="fields"
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :v-model:sort-by="sortBy"
                      :v-model:sort-desc="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      @filtered="onFiltered"
                  ></b-table>
                </div>
                <div class="row">
                  <div class="col">
                    <div
                        class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Orçamentos" disabled> </b-tab>
              <b-tab title="Visitas" disabled> </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
